module.exports = __webpack_public_path__ + "img/swiper-item1-d1.39ddc8f0.png";